import React, { useCallback, useEffect, useMemo, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { Backdrop, Box, Card, CircularProgress, Divider, Typography, useMediaQuery } from '@mui/material'
import { getFromStorage } from '../../utils/storage'
import axios from 'axios'
import { DOMAIN } from '../../utils/api'
import { handleError } from '../../utils/error'
import { currentUserActions } from '../../redux/store'
import { mainGreen, mainRed } from '../../utils/color'

export default function CheckFreshStockHistory() {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { date } = useParams()
	const mediaMd = useMediaQuery('(min-width:768px)')
	const token = getFromStorage('current-user')?.accessToken
	const { currentUser } = useSelector((state) => state.currentUser)
	const [loadingSearch, setLoadingSearch] = useState(true)
	const [currentImage, setCurrentImage] = useState(null)
	const [isViewerOpen, setIsViewerOpen] = useState(false)
	const [history, setHistory] = useState([])
	const dateRange = useMemo(
		() => ({
			firstTimePick: {
				date: date.slice(0, 2),
				month: date.slice(2, 4),
				year: date.slice(4, 8),
			},
			secondTimePick: {
				date: date.slice(8, 10),
				month: date.slice(10, 12),
				year: date.slice(12, 16),
			},
		}),
		[date],
	)

	const openImageViewer = (photo) => {
		setCurrentImage(photo)
		setIsViewerOpen(true)
	}

	const closeImageViewer = () => {
		setCurrentImage(null)
		setIsViewerOpen(false)
	}

	const getHistory = useCallback(
		async function () {
			try {
				const response = await axios({
					url: `${DOMAIN}/sub-stock/check-fresh-stock-history/${currentUser.store}`,
					method: 'POST',
					data: {
						firstTimePick: dateRange.firstTimePick,
						secondTimePick: dateRange.secondTimePick,
					},
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setHistory(response.data)
				setLoadingSearch(false)
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[currentUser.store, dateRange, token, dispatch, navigate],
	)

	useEffect(() => {
		getHistory()
	}, [getHistory])

	return (
		<UserLayout>
			{loadingSearch ? (
				<Box display='flex' justifyContent='center' sx={{ marginTop: '120px' }}>
					<CircularProgress sx={{ color: mainGreen }} />
				</Box>
			) : (
				<Card
					sx={{
						padding: '20px 20px 10px 20px',
						background: '#fff',
					}}>
					<Box sx={{ textAlign: 'center', mb: 2 }}>
						<Typography sx={{ fontWeight: 'bold' }}>
							LỊCH SỬ KIỂM KHO SỐNG
							<br />
							TỪ {dateRange.firstTimePick.date}/{dateRange.firstTimePick.month}/{dateRange.firstTimePick.year} ĐẾN{' '}
							{dateRange.secondTimePick.date}/{dateRange.secondTimePick.month}/{dateRange.secondTimePick.year}
						</Typography>
					</Box>
					<Backdrop
						sx={{
							color: '#fff',
							zIndex: 999,
							left: mediaMd ? 300 : 0,
						}}
						open={isViewerOpen}
						onClick={closeImageViewer}>
						<img
							loading='lazy'
							src={currentImage}
							alt='attach'
							style={{
								maxHeight: '70%',
								maxWidth: '90%',
							}}
							onClick={(e) => {
								e.stopPropagation()
							}}
						/>
					</Backdrop>
					{history.length === 0 && (
						<Typography sx={{ textAlign: 'center', fontStyle: 'italic' }}>(Chưa có dữ liệu)</Typography>
					)}
					{history.map((item, index) => {
						return (
							<div key={index}>
								<Typography sx={{ textAlign: 'left', mt: 1 }}>
									<b>{item.user?.name}</b>{' '}
									<span style={{ color: mainGreen }}>
										kiểm kho, tồn thực tế <b>{item?.quantity?.toFixed(1)}kg</b>
									</span>
									. Hệ thống{' '}
									<span style={{ color: mainGreen }}>
										<b>
											{item?.checkStockSystem?.toFixed(1)}
											kg.
										</b>{' '}
									</span>
									Chênh lệch:{' '}
									{item?.quantity - item?.checkStockSystem > 0 ? (
										<b>+{(item?.quantity - item?.checkStockSystem)?.toFixed(1)}</b>
									) : (
										<b>{(item?.quantity - item?.checkStockSystem)?.toFixed(1)}</b>
									)}
									kg. <b>{item?.confirmCheckStock?.user.name}</b> đã duyệt.
								</Typography>
								<Box display='flex' justifyContent='flex-end' alignItems='flex-end' sx={{ mb: 1 }}>
									{item?.checkStockPicture && (
										<img
											loading='lazy'
											src={item?.checkStockPicture}
											onClick={() => {
												openImageViewer(item?.checkStockPicture)
											}}
											width='30'
											height='30'
											style={{
												marginRight: '8px',
												marginTop: '2px',
												cursor: 'pointer',
											}}
											alt=''
										/>
									)}
									{item?.checkStockMultiPicture?.map((img, index) => {
										return (
											<img
												loading='lazy'
												key={index}
												src={img}
												onClick={(e) => {
													openImageViewer(img)
												}}
												width='30'
												height='30'
												style={{
													marginRight: '8px',
													marginTop: '2px',
													cursor: 'pointer',
												}}
												alt=''
											/>
										)
									})}
									<Typography
										style={{
											fontStyle: 'italic',
											fontSize: '12px',
											textAlign: 'right',
										}}>
										- {item?.timeStamp} -{' '}
										{item?.confirmCheckStock && (
											<span style={{ color: mainRed }}>Duyệt: {item?.confirmCheckStock.timeStamp}</span>
										)}
									</Typography>
								</Box>
								<Divider />
							</div>
						)
					})}
				</Card>
			)}
		</UserLayout>
	)
}
